import { lang } from '@umu/ukit-lang';
import { TScopeLangType, TScopeLangMap, IScopeLangStore } from '@umu/umu-types/src/interface/practice';
class ScopeLangStore implements IScopeLangStore {
    public scopeLangMap: TScopeLangMap = {};
    public scopeLangType: TScopeLangType = 'umu';

    constructor(scopeLangMap: TScopeLangMap, scopeLangType: TScopeLangType = 'umu') {
        this.scopeLangMap = scopeLangMap;
        this.scopeLangType = scopeLangType;
    }

    transformKeyUmuToUse(key: string) {
        return key.replace('作业', '练习').replace('讲师', '经理').replace('学员互评', '互评');
    }

    getScopeLang(key: string, ...args: any[]) {
        return this.getScopeLangByType(key, this.scopeLangType, ...args);
    }

    getScopeLangByType(key: string, type: TScopeLangType, ...args: any[]) {
        if (!this.scopeLangMap[key]) {
            return key;
        }

        try {
            const value = this.scopeLangMap[key]?.[type];
            if (typeof value === 'function') {
                return value(args);
            }
            return value || lang(this.transformKeyUmuToUse(key));
        } catch (error) {
            return key;
        }
    }
}

export default ScopeLangStore;
